<template>
  <div
    class="highlights-container p-3"
    v-if="highlightsList.length > 0"
    :class="propWhiteBackground ? 'bg-light' : ''"
  >
    <div class="container">
      <!-- Section Header -->
      <div class="section-header text-center mb-4">
        <div class="col-12 text-primary text-center text-uppercase" style="letter-spacing: 0.05em; line-height: 1.8; font-weight: 600; font-size: 2rem;">Évènements</div>

        <!-- <h3 class="text-secondary text-center">Découvrez nos dernièrs événements</h3> -->

      </div>

      <!-- Carousel Navigation Arrows -->
      <div class="row align-items-center text-center">
        <div class="col-1 d-none d-sm-block">
          <a href="javascript:void(0);" @click="$refs.hightlightprev.click();" class="nav-arrow">
            <i class="fas fa-chevron-left text-dark"></i>
          </a>
        </div>
        <div class="col-12 col-sm-10">
          <carousel id="high-car" v-if="highlightsList.length > 0" :smartSpeed="2000" :autoplay="false" :autoplayHoverPause="true" :nav="false"  :dots="false"  :loop="true" 
            :items="1"  :responsive="{0:{items:1}, 576:{items:1}, 768:{items:1}, 992: {items:1}, 1200: {items:1}, 1400: {items:1}}"
              :margin="25">

              <template slot="prev"><span hidden ref="hightlightprev" class="prev">prev</span></template>
              <template slot="next"><span hidden  ref="hightlightnext" class="next">next</span></template>

                  <div class=" p-sm-2 p-0 " v-for="(announcement) in this.highlightsList" :key="announcement.id">
                      <img :src="'/api/image/get/' + announcement.image"   style="border: 1px solid #ecedf0; border-radius:7px; width: 100%; height: auto;" >
                      
                      <div v-if="propDisplayTitle" class=" mt-4">
                        <h5 class="text-primary text-uppercase mb-2 font-weight-bold">{{announcement.title}} </h5>
                        <span class="text-dark font-size-14"> <strong>{{announcement.date}}</strong></span>
                      </div>
                  </div>

          </carousel>
        </div>



        <div class="col-1  d-none d-sm-block">
          <a href="javascript:void(0);" @click="$refs.hightlightnext.click();" class="nav-arrow">
            <i class="fas fa-chevron-right text-dark"></i>
          </a>
        </div>

      </div>




    </div>
  </div>
</template>

<script>
import AnnouncementsApi from "@/services/announcements-api";
import carousel from "vue-owl-carousel";

export default {
  props: {
    propDisplayTitle: {
      type: Boolean,
      default: true,
    },
    propWhiteBackground: {
      type: Boolean,
      default: true,
    },
    propFullwidth: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    carousel,
  },
  data() {
    return {
      highlightsList: [],
    };
  },
  mounted() {
    this.getHighlights();
  },
  methods: {
    async getHighlights() {
      try {
        const result = await AnnouncementsApi.getHighlights(1, 100);
        if (result) {
          this.highlightsList = result.list;
        }
      } catch (error) {
        console.error("Error fetching highlights:", error);
      }
    },
  },
};
</script>

<style scoped>
/* Container */
.highlights-container {
  padding: 2rem 0;
  border-radius: 8px;
}

/* Section Header */
.section-header {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 2rem;
  font-weight: bold;
}

.section-subtitle {
  font-size: 1.25rem;
}

/* Carousel Navigation */
.carousel-navigation {
  margin-bottom: 1.5rem;
}

.nav-arrow {
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;
}

.nav-arrow:hover {
  color: #007bff;
}

/* Carousel Items */
.carousel-item {
  padding: 0 10px;
}

.card {
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
}

.card-img-top {
  border-radius: 8px 8px 0 0;
  height: 200px;
  object-fit: cover;
}

.card-body {
  padding: 1rem;
}

.card-title {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.card-text {
  font-size: 0.875rem;
  color: #666;
}
</style>